import { render, staticRenderFns } from "./compare_versions_dropdown.vue?vue&type=template&id=2fb1ab02&"
import script from "./compare_versions_dropdown.vue?vue&type=script&lang=js&"
export * from "./compare_versions_dropdown.vue?vue&type=script&lang=js&"
import style0 from "./compare_versions_dropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "compare_versions_dropdown.vue"
export default component.exports